import { useCallback, useEffect, useState, useRef} from "react";
import { Button } from "react-bootstrap";
import LanguageList from "components/LanguageList";
import { useAppSettings } from "shared/context/AppSettingsContext";
import { languageService } from "services";
import "./styles.scss";
import {LuArrowRightLeft} from "react-icons/lu";
import useOutsideClick from "shared/hooks/useOutsideClick"

function LanguageSelector({ onLangSelectorShowToggle }) {
    const appSettings = useAppSettings();
    const sourceLanguage = appSettings.settings.sourceLanguage;
    const targetLanguage = appSettings.settings.targetLanguage;
    const [showList, setShowList] = useState(!targetLanguage);

    const toggleList = () => {
        setShowList(!showList);
    }

    const onLangSelect = useCallback((targetLanguage, targetDialect) => {
        appSettings.updateSettings({
            targetLanguage,
            targetDialect,
            targetLocale: languageService.getLocale(targetLanguage, targetDialect),
        });
        toggleList();
    }, []);

    useEffect(() => {
        setShowList(!targetLanguage);
    }, [targetLanguage]);

    useEffect(() => {
        onLangSelectorShowToggle?.(showList);
    }, [showList]);

    const wrapperRef = useRef(null);
     useOutsideClick(wrapperRef, () => {
        if(targetLanguage)
         setShowList(false);
     });

    return (
        <div ref={wrapperRef} className="language-selector">
            <div className="position-relative d-inline-block lang-selector-wrapper">
                <Button variant="primary" size="lg" className="lang-selector-btn w-100 fs-4" onClick={() => targetLanguage && toggleList()}>
                    <span>{sourceLanguage.langText}</span>< LuArrowRightLeft className="mx-2 mx-sm-3" /><span className="fw-bold">{targetLanguage?.langText || "Select"}</span>
                </Button>
            </div>
            <LanguageList show={showList} langList={languageService.SupportedLanguages} targetLanguage={targetLanguage} onLangSelect={onLangSelect} />
        </div>
    )
}

export default LanguageSelector;
